import apiClient from "./axios"

// Get list of engine types with optional params
export const getEngineTypes = async (params = {}) => {
  const { data } = await apiClient.get("/engine-types", { params })
  return data
}

// Get single engine type by ID
export const getEngineType = async (id) => {
  const { data } = await apiClient.get(`/engine-types/${id}`)
  return data
}

// Create new engine type
export const createEngineType = async (payload) => {
  const { data } = await apiClient.post("/engine-types", payload)
  return data
}

// Edit existing engine type
export const editEngineType = async ({ id, ...payload }) => {
  const { data } = await apiClient.put(`/engine-types/${id}`, payload)
  return data
}

// Delete engine type by ID
export const deleteEngineType = async (id) => {
  const { data } = await apiClient.delete(`/engine-types/${id}`)
  return data
}
